import { useState } from "react";

import { createError, parseGraphQLError } from "utils";

import { useAsyncCall, useMutation as useSpecialQuery } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import { useOnboardingStepsData } from "scenes/Onboarding/components/OnboardingStepsProvider";

const queryFactory = () => {
  const query = `query billingPriceEstimate($coupons: [String]!, $planId: String!) {
                  billingPriceEstimate(coupons: $coupons, planId: $planId) {
                    coupons {
                      id
                      discountAmount
                      discountDetails
                    }
                    billingPrice
                    monthlyPrice
                  }
                }`;

  const resolver = ({ data: { billingPriceEstimate } }) => {
    return {
      coupon: { ...billingPriceEstimate.coupons[0] },
      billingPrice: billingPriceEstimate.billingPrice,
      monthlyPrice: billingPriceEstimate.monthlyPrice,
    };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

function useCouponDiscount(onCouponChange) {
  const [call, loading] = useAsyncCall();
  const [error, setError] = useState();
  const { store, dispatch } = useOnboardingStepsData();

  const query = useSpecialQuery(queryFactory);

  const updateStepData = (updatedData) => {
    dispatch({
      type: "update-step-data",
      value: { subscription: { ...store.subscription, ...updatedData } },
    });
  };

  const createErrorObj = (e, coupon) => {
    return createError({
      ...parseGraphQLError(e),
      name: "GetCouponPriceEstimate",
      defaultMessage:
        "Unexpected error ocurred, please reach out to support@myhubly.com",
    });
  };

  const calculateCouponDiscount = async ({ name }) => {
    return call(async () => {
      try {
        setError(null);

        const discount = await query({
          coupons: [name],
          planId: store.subscription.planId,
        });

        if (discount) {
          onCouponChange({ ...discount.coupon, name: name });
          updateStepData({
            discountedBillingPrice: {
              total: discount.billingPrice,
              monthly: discount.monthlyPrice,
            },
            coupons: [discount.coupon.id],
          });
        }
      } catch (e) {
        setError(createErrorObj(e, name).message);
      }
    });
  };

  const removeCoupon = () => {
    onCouponChange(null);
    updateStepData({ discountedBillingPrice: null, coupons: null });
  };

  return { calculateCouponDiscount, removeCoupon, loading, error };
}

export default useCouponDiscount;
